export function getBrowserLanguage () {
  const languageMap = {
    en: 'en',
    id: 'id'
  }
  const [browserLanguage] = (navigator.language || navigator.browserLanguage).split('-')

  return languageMap[browserLanguage] || 'en'
}
